import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React, { useEffect, useRef } from 'react';
import * as debug from '../../../lib/debug';
import throttle from 'lodash/throttle';
import styled from 'styled-components';
import { useBoolean, useStateful } from 'react-hanger';

const log = debug.create('scrollBar');

const Wrap = styled(OverlayScrollbarsComponent)`
  height: 100%;
  //width: 100%;
  div[data-overlayscrollbars-contents] {
    scroll-behavior: smooth;
  }
`;

const Index = (props) => {
  const {
    children,
    dark = true,
    isReachBottom = false,
    onReachBottom,
    onReachBottomChange,
    options: scrollOptions,
    className = '',
    // overflow, // {x:'scroll',y:'scroll'}
    scrollIndex,
    ...rest
  } = props;

  const isMouseOn = useBoolean(false);

  const osRef = useRef();

  const handleMouseEnter = () => {
    isMouseOn.setTrue();
  };
  const handleMouseLeave = () => {
    isMouseOn.setFalse();
  };

  useEffect(() => {
    if (isReachBottom) {
      log('isReachBottom is true, scrollTo bottom');
      osRef.current?.osInstance()?.elements().scrollOffsetElement.scrollTo(0, 100000);
    }
  }, [isReachBottom, scrollIndex]);

  const events = {
    scroll: throttle((instance, event) => {
      const { scrollHeight, scrollTop, offsetHeight } = event.target;
      const reachBottom =
        scrollHeight > offsetHeight && scrollHeight - offsetHeight - scrollTop < 20;
      if (reachBottom) {
        onReachBottom && onReachBottom();
      }
      log('[scroll]', { reachBottom });
      onReachBottomChange && onReachBottomChange(reachBottom);
    }, 200),
    updated: throttle((instance, onUpdatedArgs) => {
      if (isReachBottom) {
        log('[updated] scrollTo bottom');
        instance.elements().scrollOffsetElement.scrollTo(0, 100000);
      }
    }, 200),
  };

  const options = {
    scrollbars: {
      theme: 'os-theme-light', //`${dark ? 'os-theme-dark' : } `,
      autoHide: 'leave',
    },
    ...scrollOptions,
  };

  return (
    <Wrap
      className={`scroll ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      options={options}
      events={events}
      ref={osRef}
      {...rest}
    >
      {children}
    </Wrap>
  );
};

export default Index;
